/**
  The linearGradient() function helps you to create a linear gradient color background
 */

function linearGradient(color: string | string[], colorState: any, angle = 310) {
  if (typeof color === 'string') return `linear-gradient(${angle}deg, ${color}, ${colorState})`;
  if (Array.isArray(color)) return `linear-gradient(90deg, ${color.join(', ')})`;
}

export default linearGradient;
